import { h, defineComponent } from 'vue';
import { Field, FieldProps } from '@/ui/components/form/Field';
import { PhoneNumberInput, PhoneNumberInputProps, PhoneNumberUpdateData } from '@/ui/components/form/PhoneNumberInput';
import { SetterCallback } from '@/ui/types';

interface PhoneNumberFieldProps extends FieldProps, PhoneNumberInputProps {}

const fieldPropsDefinition = ['label', 'name', 'required', 'errors', 'hideLabel', 'horizontal'];
const inputPropsDefinition = [
  'value', 'size', 'noValidation', 'placeholder', 'showCodeOnList', 'disabled', 'translations', 'noExample',
];

export const PhoneNumberField = defineComponent<PhoneNumberFieldProps>({
  name: 'PhoneNumberField',
  props: [...inputPropsDefinition, ...fieldPropsDefinition],
  setup(props, ctx) {
    const fieldProps: FieldProps = {
      label: props.label,
      name: props.name,
      required: props.required,
      errors: props.errors,
      hideLabel: props.hideLabel,
      horizontal: props.horizontal,
    };

    const inputProps: PhoneNumberInputProps = {
      value: props.value,
      size: props.size,
      noValidation: !!props.noValidation,
      placeholder: props.placeholder || '',
      showCodeOnList: !!props.showCodeOnList,
      noExample: !!props.noExample,
      disabled: !!props.disabled,
      translations: props.translations,
    };

    return function render() {
      return h(Field, { props: fieldProps }, [
        h(PhoneNumberInput, {
          class: 'phone-number-input',
          props: inputProps,
          on: {
            input: (v: string) => ctx.emit('input', v),
            update: (v: PhoneNumberUpdateData) => ctx.emit('update', v),
          },
        }),
      ]);
    };
  },
});

export function phoneNumberField(
  props: PhoneNumberFieldProps, input: SetterCallback<string>, update: SetterCallback<PhoneNumberUpdateData>,
) {
  return h(PhoneNumberField, {
    props,
    on: { input, update },
  });
}
